module.exports = __webpack_public_path__ + "static/media/Objects.2a3defa7.svg";